export function findTierNumber(currentTierId, tiers = []) {
  const matchingTier = tiers.find(tier => tier.id === currentTierId);
  return matchingTier?.tierNumber ?? null;
}
